import { isEvmNamespace } from '@hub3js/evm';
import { isSolanaNamespace } from '@hub3js/solana';
import { DefaultEvmSigner } from '@rango-dev/signer-evm';
import { DefaultSignerFactory, TransactionType } from 'rango-types';
import { privyAdapter } from '../adapter';
import { providerGeneralMetadata } from './constants';
import { SolanaSigner } from './signers/solana';
export function getMetaData() {
    return {
        ...providerGeneralMetadata,
        properties: [
            {
                name: 'namespaces',
                value: {
                    selection: 'multiple',
                    data: [
                        {
                            label: 'EVM',
                            value: 'EVM',
                            id: 'ETH',
                            isChainSupported: isEvmNamespace,
                        },
                        {
                            label: 'Solana',
                            value: 'Solana',
                            id: 'SOLANA',
                            isChainSupported: isSolanaNamespace,
                        },
                    ],
                },
            },
            {
                name: 'signers',
                value: {
                    getSigners: async () => {
                        const { privyEvmWallets, privySolanaWallets } = privyAdapter.getPrivyContext();
                        const evmInstance = await getEmbeddedEvmWallet(privyEvmWallets)?.getEthereumProvider();
                        const solanaInstance = privySolanaWallets[0];
                        const signers = new DefaultSignerFactory();
                        if (evmInstance) {
                            signers.registerSigner(TransactionType.EVM, new DefaultEvmSigner(evmInstance));
                        }
                        if (solanaInstance) {
                            signers.registerSigner(TransactionType.SOLANA, new SolanaSigner(solanaInstance));
                        }
                        return signers;
                    },
                },
            },
        ],
    };
}
export function getEmbeddedEvmWallet(privyEvmWallets) {
    return privyEvmWallets?.filter((wallet) => wallet.connectorType === 'embedded')?.[0];
}
/**
 * Resolves the embedded Privy EVM wallet's EIP-1193 provider, or `undefined`
 * when there is no embedded wallet.
 */
export async function getEmbeddedEvmProvider() {
    const { privyEvmWallets } = privyAdapter.getPrivyContext();
    return (await getEmbeddedEvmWallet(privyEvmWallets)?.getEthereumProvider());
}
export function checkIsPrivyReadyForConnect(context) {
    return (context.ready &&
        !!context.user &&
        !!getEmbeddedEvmWallet(context.privyEvmWallets) &&
        !!context.privySolanaWallets?.length);
}
